"use client";

import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { PermissionsProvider } from "@/context/permissions-context";
import { useMemo, useState, useEffect } from "react";

export function PermissionsProviderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const user = useSelector((state: RootState) => state.user.user);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const permissions = useMemo(() => {
    if (!mounted || !user?.role?.scopes) {
      return [];
    }
    return user.role.scopes
      .map((scope) => scope.code)
      .filter((code): code is string => Boolean(code));
  }, [mounted, user?.role?.scopes]);

  return (
    <PermissionsProvider permissions={permissions}>
      {children}
    </PermissionsProvider>
  );
}

